export default "__VITE_ASSET__7$P7mEz2__"